<div class="login-content">
  @if (errorMessage) {
    <div class="snackbar snackbar-red justify-center">{{ errorMessage }}</div>
  }
  @if (successMessage) {
    <div class="snackbar snackbar-green justify-center">
      {{ successMessage }}
    </div>
  }
  <div class="page-title justify-center">
    <span class="font-medium-display-small text-center">
      Passwort vergessen
    </span>
  </div>
  <form
    class="flex-c form-content"
    [formGroup]="forgotForm"
    (ngSubmit)="forgotPassword()">
    <span class="form-description">
      Wir senden dir einen Link per E-Mail, damit du dein Passwort zurücksetzen
      kannst.
    </span>
    <div class="form-group">
      <label class="input-label" for="email">E-Mail</label>
      <input
        type="email"
        class="form-control input-text"
        [class]="{
          'input-error':
            forgotForm.get('email').invalid && forgotForm.get('email').touched,
          'input-success':
            forgotForm.get('email').valid && forgotForm.get('email').touched,
        }"
        id="email"
        formControlName="email"
        placeholder="E-Mail"
        autocomplete="on" />
      <!-- Error Messages -->
      <app-error-message
        [formField]="forgotForm.get('email')"></app-error-message>
    </div>
    <div class="form-button">
      <button type="submit" class="inwi-text-button-large-primary">
        Passwort zurücksetzen
      </button>
    </div>
  </form>
</div>
